import Swiper from "swiper";
import { Mousewheel, Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";

class CardsSwiper {
  constructor(el) {
    this.el = el;
    this.swiper = this.el.querySelector(".swiper");

    if (this.swiper) {
      new Swiper(this.swiper, {
        // autoHeight: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        spaceBetween: 15,
        slidesPerView: 1.3,
        loop: false,
        grabCursor: true,
        direction: "horizontal",
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },

        breakpoints: {
          667: {
            slidesPerView: 2.3,
          },
          768: {
            slidesPerView: 2.3,
          },
          992: {
            slidesPerView: 3.3,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
          },
          1200: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            pagination: false,
            navigation: false,
          },

        },
        navigation: {
          prevEl: this.el.querySelector(".cards-sec .swiper-arrows__prev"),
          nextEl: this.el.querySelector(".cards-sec .swiper-arrows__next"),
        },
        modules: [Navigation, Mousewheel],
      });
    }
  }
}

function initCardsSwiper() {
  const sliders = document.querySelectorAll(".cards-sec__swiper");
  for (let slider of sliders) {
    new CardsSwiper(slider);
  }
}

initCardsSwiper();
